import { DateRangeFilter } from 'owa-files-filter-date-filter';
import { FileExtensionType } from 'owa-files-filter-file-extensions-filter';
import { action } from 'satcheljs';

export const onFilterMenuIsOpenChanged = action('onFilterMenuIsOpenChanged', (isOpen: boolean) => ({
    isOpen: isOpen,
}));

// Date range filter context menu actions
export const clearDateFilterAction = action('clearDateFilterAction');
export const clearFileExtensionsFiltersAction = action('clearFileExtensionsFiltersAction');

export const selectDateFilterAction = action(
    'selectDateFilterAction',
    (value: DateRangeFilter) => ({
        value: value,
    })
);

export const selectLinksContextMenuItemAction = action('selectLinksContextMenuItemAction');
export const clearLinksContextMenuItemAction = action('clearLinksContextMenuItemAction');

// Extension filter context menu actions

export const selectImageContextMenuItemAction = action('selectImageContextMenuItemAction');
export const selectAllFilesContextMenuItemAction = action('selectAllFilesContextMenuItemAction');
export const selectFileExtensionAction = action(
    'selectFileExtensionAction',
    (value?: FileExtensionType) => ({
        value: value,
    })
);

export const clearExtensionFilterAction = action(
    'clearExtensionFilterActionFilter',
    (value?: FileExtensionType) => ({
        value: value,
    })
);

export const clearExtensionGroupFilterAction = action('clearExtensionGroupFilterAction');

export const selectExtensionFilterAction = action(
    'selectExtensionFilterAction',
    (value: FileExtensionType) => ({
        value: value,
    })
);

export const expandFileExtensionsFilterMenu = action('expandFileExtensionsFilterMenu');

export const collapseFileExtensionsFilterMenu = action('collapseFileExtensionsFilterMenu');
